<template>
    <div class="generate_invoices">
        <div>
            <button @click="openGenerationWindow" class="inputbutton1">Generate {{ invoice_type | snakeToTitleCase}}</button>
        </div>
        <modal
            v-if="showInvoiceNumberModal"
            modal-width="500px"
            @close="closeModal"
        >
            <h4 slot="header">Generate Invoice</h4>
            <div slot="body">
                <div class="form-group">
                    <label>Invoice Number</label>
                    <input type="text" class="form-control" v-model="invoice_number" />
                </div>
                <div class="form-group">
                    <preview-pdf
                        :preview-url="customerInvoiceUrl"
                        :download-url="customerInvoiceDownloadUrl"
                        :open-label="previewPdfLabel"
                        class="my-2"
                        :disabled="!canPreviewAndGenerate"
                    ></preview-pdf>
                    <adobe-sign-request
                        v-if="canPreviewAndGenerate && useAdobeSign"
                        model-type="project"
                        :model-id="project.id"
                        agreement-type="customer-invoice"
                        :additional-args="{phase: phase.id, invoice_number: invoice_number}"
                        :generate-text="adobeSignGenerateText"
                        :regenerate-text="adobeSignRegenerateText"
                        :sign-text="adobeSignSigningText"
                    ></adobe-sign-request>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import { snakeToTitleCase } from 'etap/filters/snake_to_title_case';

    export default {
        props: {
            phase: {
                required: true,
                type: Object,
            },
            project: {
                required: true,
                type: Object,
            },
            useAdobeSign: {
                type: Boolean,
                default: false,
            },
            download: {
                type: Boolean,
                default: false,
            },
            invoice_type: {
                required: true,
                type: String,
            },
            previewPdfLabel: {
                required: true,
                type: String,
                default: 'Preview Report'
            },
            adobeSignGenerateText: {
                required: true,
                type: String,
                default: 'Generate Agreement'
            },
            adobeSignRegenerateText: {
                required: true,
                type: String,
                default: 'Re-generate Agreement'
            },
            adobeSignSigningText: {
                required: true,
                type: String,
                default: 'Signed Program Agreement'
            }
        },
        data() {
            return {
                canPreviewAndGenerate: false,
                invoice_number: this.project.shared_project_id,
                showInvoiceNumberModal: false,
            }
        },
        created() {
            if(this.invoice_number) {
                this.canPreviewAndGenerate = true;
            }
        },
        filters: {
            snakeToTitleCase
        },
        computed: {
            customerInvoiceUrl() {
                if(this.validateInvoiceNumber()) {
                    return '/project/' +this.project.id + '/generate_invoice?action=view&invoice_type=' + this.invoice_type + '&invoice_number=' + this.invoice_number;
                }

                return '';
            },
            customerInvoiceDownloadUrl() {
                if(this.validateInvoiceNumber()) {
                    return '/project/' + this.project.id + '/generate_invoice?action=view&invoice_type=' + this.invoice_type + '&invoice_number=' + this.invoice_number + '&download=1';
                }

                return '';
            }
        },
        methods: {
            openGenerationWindow() {
                this.showInvoiceNumberModal = true;
            },
            validateInvoiceNumber() {

                if(this.invoice_number) {
                    this.canPreviewAndGenerate = true;
                    return true;
                }

                this.canPreviewAndGenerate = false;
                return false;
            },
            closeModal() {
                this.showInvoiceNumberModal = false;
                this.invoice_number = this.project.shared_project_id;
            }
        }
    }
</script>
